var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"short-video-player"},[_c('swiper-video',{attrs:{"videoList":_vm.videoList,"innerWidth":_vm.w,"innerHeight":_vm.h},on:{"reachEnd":_vm.reachEnd,"slideChange":_vm.slideChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }